import { useEffect } from 'react';
import { useAppStore } from '@/store';
import { loadProfiles, saveProfile } from '@/persistence/profileRepository';

export function usePersistence(): void {
  const profiles = useAppStore((s) => s.profiles);

  // Load profiles on mount
  useEffect(() => {
    loadProfiles().then((loaded) => {
      if (loaded.length > 0) {
        useAppStore.setState({ profiles: loaded, activeProfileId: loaded[0]?.id ?? null });
      }
    });
  }, []);

  // Auto-save profiles on change
  useEffect(() => {
    for (const profile of profiles) {
      saveProfile(profile);
    }
  }, [profiles]);
}
